import {PureComponent} from "react";

export default class PortalPureComponent<PROPERTY_TYPE = any, STATUS_TYPE = any>
	extends PureComponent<PROPERTY_TYPE, STATUS_TYPE> {
	protected mounted: boolean;

	constructor(props: Readonly<PROPERTY_TYPE>) {
		super(props);

		this.state = {} as STATUS_TYPE;

		this.mounted = false;
	}

	public setState<K extends keyof STATUS_TYPE>(
		state: ((
			prevState: Readonly<STATUS_TYPE>, props: Readonly<PROPERTY_TYPE>
		) => (Pick<STATUS_TYPE, K> | STATUS_TYPE | null)) | Pick<STATUS_TYPE, K> | STATUS_TYPE | null,
		callback?: () => void
	) {
		if (!this.mounted) {
			return;
		}

		super.setState(state, callback);
	}

	/**
	 * This is called when the component is mounted
	 */
	public async componentDidMount(): Promise<void> {
		this.mounted = true;
	}

	/**
	 * This is called when the component is unmounted
	 */
	public async componentWillUnmount(): Promise<void> {
		this.mounted = false;
	}
}